'use client'

import { zodResolver } from '@hookform/resolvers/zod'
import { useEffect } from 'react'
import { useForm, useWatch } from 'react-hook-form'

import { Card } from '@/entities/auth'
import { SignUpHostButton, useSignUpHostStore } from '@/features/sign-up'
import { THostPayForm, ZHostPayForm } from '@/features/sign-up'
import { AccountVerificationProvider } from '@/features/update-account'
import { Slot, useDebounce } from '@/shared/lib'
import { Form } from '@/shared/ui'

import { HostPayAccount } from './host-pay-account'
import { ReceiptForFee } from './receipt-for-fee'
import { RecommenderPhoneNumber } from './recommender-phone-number'

export const SignUpHostPay = () => {
  const { actions, pay } = useSignUpHostStore()

  const form = useForm<THostPayForm>({
    defaultValues: pay,
    resolver: zodResolver(ZHostPayForm),
    reValidateMode: 'onSubmit',
  })

  const watch = useWatch({
    control: form.control,
  })

  const debouncedWatch = useDebounce(watch, 300)

  useEffect(() => {
    actions.updatePay(debouncedWatch as THostPayForm)
  }, [debouncedWatch, actions])

  return (
    <Form.Root form={form}>
      <AccountVerificationProvider>
        <Card progress={75}>
          <Slot name="title">정산 정보를 입력해 주세요</Slot>
          <Slot name="children">
            <HostPayAccount />
            <ReceiptForFee />
          </Slot>
          <Slot name="subContent">
            <RecommenderPhoneNumber />
            <SignUpHostButton />
          </Slot>
        </Card>
      </AccountVerificationProvider>
    </Form.Root>
  )
}
